/**
 * Per-language overlay dictionaries — the 2026-08-04 full-localization pass.
 *
 * One file per language (`./ar`, `./hi`, …), each exporting a flat
 * `dict: source-string → translation`. Lookups fall through
 * `T[key]?.[lang] ?? OVERLAYS[lang]?.[key] ?? key` in `t()`, so anything a
 * dict omits degrades to the English source — never to a crash.
 *
 * Split per language on purpose: each file is independently editable and
 * reviewable, and translators never touch the shared table in index.ts.
 */
import type { Lang } from '../index';
import { dict as ar } from './ar';
import { dict as bn } from './bn';
import { dict as fa } from './fa';
import { dict as hi } from './hi';
import { dict as ml } from './ml';
import { dict as ne } from './ne';
import { dict as pa } from './pa';
import { dict as ru } from './ru';
import { dict as si } from './si';
import { dict as ta } from './ta';

export const OVERLAYS: Partial<Record<Lang, Record<string, string>>> = {
  ar,
  bn,
  fa,
  hi,
  ml,
  ne,
  pa,
  ru,
  si,
  ta,
};
